// Product Tabs Video - Collapse Functionality
document.addEventListener('DOMContentLoaded', function() {
  
  // Get all tab triggers
  const tabTriggers = document.querySelectorAll('.tab-trigger');
  
  tabTriggers.forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      const tabId = this.getAttribute('data-tab-id');
      const tabContent = document.getElementById(tabId);
      
      // Toggle active class on trigger
      this.classList.toggle('active');
      
      // Toggle active class on content
      if (tabContent) {
        tabContent.classList.toggle('active');
      }
    });
  });
  
});